import { render, staticRenderFns } from "./198.vue?vue&type=template&id=05ca3a14&scoped=true&"
var script = {}
import style0 from "./198.vue?vue&type=style&index=0&id=05ca3a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ca3a14",
  null
  
)

export default component.exports